module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uKukmZ2P33VPQlEmjKvRCBC",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "uWFOhmk5wvxn3lzlMvwEhY6"
    }
  }), _vm._v("CHAPTER FOUR ")])]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER-",
    attrs: {
      "id": "uesADiVDtEAim29U8ejsGPB",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "uIiIKzkyETLSihb32O9o73H"
    }
  }), _vm._v("ZELLNER FACTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Just four days before the twelve-year anniversary of Teresa’s mysterious Manitowoc County murder, the condemned prisoner made a prepaid collect call from his permanent residence behind the walls of the Waupun Correctional Center. The simple man had gained the unwavering support of millions of men and women across the globe, people whose lives were forever touched by the Emmy-winning documentary. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But their lives have never intersected with the plight of Steven Avery, a man unjustly imprisoned and snatched from society for eighteen long years, starting in his early twenties. This same man, at age forty-three, was on the verge of collecting a multi-million dollar federal lawsuit settlement at the hands of law enforcement in Avery’s native Manitowoc County. Suddenly, just days before  he got to sit inside the law offices for the sworn deposition of the man responsible for his disastrous life, retired Manitowoc County Sheriff Tom Kocourek, Avery found himself ripped away from his mother and father, Dolores and Al, his brothers Chuck and Earl, and his sister, Barb. This time, unlike the last time, there was a major news media marketing campaign, long before any trial, to brand Avery a demon, a sicko, a pariah, the pond scum of the earth. The people involved in this effort included the likes of Manitowoc Sheriff Kenny Peterson, Undersheriff Rob Hermann, Manitowoc County Special Prosecutor Ken Kratz, Calumet Sheriff Jerry Pagel, Calumet County Sheriff’s Investigator Mark Wiegert and Special Agent Tom Fassbender, worked at the Wisconsin DCI.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All six liked-minded men, between their forties and sixties, were in complete agreement. Steven Avery was going to go down hard for Teresa’s murder and everyone in Wisconsin would be assured that he was a bloodthirsty monster.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Steven Avery-is-guilty pretrial publicity mantra was bigger than a tidal wave. It was a typhoon, a monsoon. At the end of the day, after a few days of back-and-forth jury deliberations, including questions surrounding the testimony of Kratz’s leadoff witness, Bobby Dassey, Avery was tried and convicted of the first-degree murder, though many people still had lingering doubts, even after trial had ended. Indeed, Avery was one of the last persons to see Teresa, but most people now believe what Avery has always professed from the get-go, that he is innocent, that he had nothing to do with her killing. What motive did he have to harm the freelance photographer from Green Bay? Rational people, objective people, people who are deep critical thinkers, struggle to find the motive. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Of course, there is another nagging question weighing on the minds of many. If Avery did not murder Teresa, then who did? And why? ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Since January 2016, Avery has had a tireless advocate who dropped into his life from Wisconsin’s dreaded rival, Illinois. Lucky for him, the suburban Chicago woman out of Downers Grove happens to be regarded as one the country’s foremost lawyers in exposing police corruption and prosecutorial misconduct. She has achieved a miraculous streak of overturning more than twenty wrongful convictions since the 1990s.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“In 23 years, Kathleen Zellner has righted more wrongful prosecutions than any private attorney in America. No private attorney in the United States has successfully won for the release of more innocent defendants,” her website proclaims.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As of September 27, 2018, the United States had 2,270 exonerations.")]), _vm._v(" "), _c('p', {
    staticClass: "captions",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "captions",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/Photo_2_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captions",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Suburban Chicago lawyer Kathleen Zellner has achieved more exonerations of wrongfully convicted prisoners than any other lawyer in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My interest in this area of law resulted in being appointed on a death penalty case, representing a serial killer. I represented an individual named Larry Eyler in the early 1990s and so I had to prepare a post-conviction. I had started my own law firm. I was the in-house counsel for a large HMO, and I was doing medical malpractice, but my clerks thought it would be interesting to see if we could tackle the complexity of a post-conviction case in 1992, with someone that everyone believed was guilty.”"), _c('span', {
    staticClass: "Endnote-Reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-014"
    }
  }, [_vm._v("(13)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Zellner said she made incredible discoveries that Eyler had only been convicted of one murder.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I realized, as we were progressing, that we were really good at what we were doing and yet I’m getting ready to overturn the one conviction for someone that I know has committed twenty-one murders. So the dilemma I was in was to try to figure out how to turn it into something positive, something good.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What I figured out was, my client was probably infected with the HIV virus, and I decided to have medical testing done, and I confirmed that he had a full blown case of AIDS. So I went to him … I persuaded him to give to me the twenty-one confessions to all the murders he had committed, in tremendous detail. And I ended up helping to close all of those cases with three jurisdictions and the FBI … and we closed all of the murder cases. I decided at that point that I would never represent someone again that I believe was guilty. I did not see myself as a criminal defense attorney, but I thought that our skill level on the Eyler case indicated that we, as small a firm as we were, could investigate and uncover evidence that the police had not and the prosecutors had not.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In 1994, Zellner took on her next case, the Joseph Burrows murder case. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The murder victim in that crime southeast of Kankakee, Illinois, was a frail eighty-eight-year-old retired farmer named William Dulin. The Iroquois County killing occurred on November 8, 1988. Dulin’s bloody body was found inside his home. Four years later, in 1992, Joseph Burrows’ murder conviction was affirmed by the Illinois Supreme Court, and he was scheduled to die by way of lethal injection, prior to Zellner’s arrival on the case.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I was called by the same group that had national funding and had given me the Eyler case so I really didn’t want to take the call,” Zellner said. “But they said to me, ‘He’s innocent. We’re very sure he’s innocent. And it’s going to take a tremendous effort because he’s facing the death penalty and he had an execution date set, within 120 days of when we took the case.’”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Zellner goes on explain how “we took Mr. Burrows’ case and we began an intensive effort to save his life and vacate his conviction and because I had been with someone who was so profoundly guilty and evil, I became an expert in recognizing innocence. And I knew that Mr. Burrows was innocent, and this was not a DNA case. This turned on the testimony of his codefendant who had committed the murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As she dug into the case, Zellner realized the slaying was all about the ballistics from where the eighty-eight-year-old farmer was slain.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“After consulting with ballistics experts, I figured out that a woman had committed the murder, the murder of an eighty-eight-year-old farmer in downstate Illinois and there had been a struggle where shots had been fired into the ceiling, and I knew that the gentleman that was killed was so frail there wouldn’t have been a struggle with my client, who was 6-foot-2 and weighed about 240 pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The codefendant, Gayle Potter, age thirty-two, got a twelve-year prison sentence under a plea agreement with prosecutors where she fingered the thirty-five-year-old Burrows as the killer and another guy as an accomplice in the small-town robbery murder. Burrows and Ralph Frye, who was also wrongfully convicted of the killing, were actually about sixty miles away in the Champaign-Urbana area at the time of Dulin’s death in tiny Iroquois County.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And she was going to be out in about twelve months,” Zellner said. “So I decided to focus all of my efforts on getting her, since I had become so skilled at getting confessions, getting her to confess to me that she had committed this murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Zellner said she knew that because of double jeopardy laws, Potter could not prosecuted for murder at that stage.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So I visited her, fifty times. And we got to know each other and we talked about Mr. Burrows’ children and the fact that he was months away from being executed and they were executing people in Illinois at that time. And she gradually came around to the position that she would testify at an evidentiary hearing which was in Kankakee, Illinois.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At that point, there had been hardly any death penalty cases in America that had ever been overturned by someone claiming to be innocent as Burrows.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So I put her on the stand, not a lot of confidence in what she would do because she was very sociopathic. So the first question I asked her was ‘Who shot William Dulin?’ And she paused and she said, ‘I shot William Dulin.’ And it was that example of the narcissistic sociopathic, but the words came out of her mouth and it saved Mr. Burrows’ life.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the end, Potter was charged with perjury, and she served three more years of Illinois prison time. She never did get the death penalty.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But I walked out the front door with him, and they took his handcuffs off, chains, we walked out the door, it was on the front page of the New York Times.  And I thought to myself, this is what I want to do with the rest of my professional career. I have gotten big verdicts. I’ve won millions of dollars in verdicts, I know that I can convince a jury …but nothing in my mind topped the experience of thinking that you’d saved someone’s life or you at least made a major contribution to saving a life.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Avery’s crusaders believe it’s only a matter of time before he will walk outside the Waupun Correctional Center in south-central Wisconsin as a smiling, teary-eyed free man, vindicated for a sloppy and corrupt murder investigation. But it took Avery eighteen years the first time around to convince the rest of the world of his innocence in the brutal attack that victimized Manitowoc businesswoman Penny Beerntsen in the late summer months of 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Naturally, a second Avery exoneration would cause heads to spin in the Wisconsin criminal justice arena. Powerful politicians from both political parties, Democrats and Republicans, would be tarnished and shamed. For the time being, Wisconsin’s judicial system, which does not have a reputation for honesty and integrity, is the last line of defense for the Avery-is-guilty faction. Wisconsin’s politically connected people are uncomfortable with the latest worldwide "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Making a Murderer")]), _vm._v(" sequel. The first documentary was downright embarrassing enough. It exposed how Wisconsin’s criminal justice system, how its small town police forces, still operate. Most of the dairy state consists of judges who are elected on popularity votes, not appointed after a rigorous interview and screening process as a number of states have established.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Although Wisconsin once had a proud reputation for being reform-oriented and one of the most progressive states in the country, it is not that way any longer. There are no meaningful reforms in Wisconsin to improve the state’s blemished reputation when it comes to small-town police work, criminal forensics, and avoiding conflicts of interest in law enforcement. These are taboo topics that are not publicly talked about. And yet Wisconsin has an overabundance of unsolved murders and cold cases, because these crimes tend to occur inside the jurisdiction of largely untrained and inexperienced police agencies and sheriff’s offices, people who are generally ill-equipped, inept, and simply not up to the task of solving complicated murder cases. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It is one thing for police cars to show up at the scene of the bloody murder and the killer is sitting on the front porch stoop with a cigarette dangling from his mouth, his hands in the air, and the bloody knife resting at the foot of his bloody sneakers. But what about the many unspeakable crimes of violence when the motive is not immediately apparent, when the killer is lurking in the shadows of society?")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If these are the cards you are dealt, and you are a condemned but innocent prisoner, then you need a lawyer who can do more than just poke holes in the original testimony and evidence offered at your first murder trial. You need a lawyer who is not just regarded as an all-star in his or her neck of the woods, but a seasoned and skilled lawyer who has the reputation of being world-class, the most valuable player in his or her legal specialization. And you need that MVP lawyer who can get you access to an entire roster of internationally renowned experts, the cream of the crop, in complicated topics like biological and genetic science, criminal behavior, computer forensics, and prosecutorial misconduct. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you are Steven Avery, you need the best of the best working on your side. You need someone such as attorney Kathleen Zellner from Illinois.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Steven Avery started writing to me in 2011. I was in the middle of a civil rights case in Washington and so I really didn’t have time to work on it and then his current girlfriend did contact me in September (2015). I did watch the documentary on Netflix. And the reason I took the case is because I felt that he had been discriminated against because his family was poor and they were uneducated. I know he’s innocent. Now, I just have to prove it.”"), _c('span', {
    staticClass: "Endnote-Reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-013"
    }
  }, [_vm._v("(14)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But starting from scratch, trying to unwind a decade-old solved murder is no easy task. The Avery case is like climbing Mount Everest. It’s wicked and nasty and there are numerous unexpected avalanches tumbling down the mountain trying to flatten Zellner and her crusaders in their quest for fairness and justice. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I do not like people that are bullies,” Zellner said. “I felt from a very young age that I was strong enough to protect people that were weaker or were victims.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Half of my exoneration cases have led to the apprehension of the real killer. I’ve probably solved way more murder cases than most homicide detectives. I think the good thing about the Netflix documentary was that it educated the public. Investigations can be corrupt, the evidence can be planted. Police officers can feel sufficiently pressured.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It goes without saying Zellner has few friends who are rooting for her to overturn Avery’s murder conviction among Wisconsin’s police law enforcement agencies. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is hardly a surprise. In Wisconsin, it’s quite common for police departments to keep their mouths shut and circle the wagons when someone in their profession gets outed for being a dirty, crooked cop.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Zellner is now in her third full year of providing free, pro bono legal representation to the world-famous Manitowoc County condemned inmate. Without Zellner’s efforts, Avery is doomed. He has no chance for parole and will surely die inside of his lonely little prison cell and many of the deep, dark, and disturbing secrets regarding the true facts of the crime would remain bottled up forever.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But now, so it seems, Zellner is in her best position to expose the shenanigans, the evidence planting, the dirty tricks played by the likes of special prosecutor Ken Kratz. She is in prime position to pull down the curtains and show to the rest of the world the many instances where the evidence pieces magically appeared at the most opportune times of the murder investigation against Avery and later his sixteen-year-old developmentally disabled nephew, Brendan. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Given the international fervor generated by the Avery murder case, and given the backlash against the brave Emmy-award winning documentarians, Moira Demos and Laura Ricciardi, who have brought Wisconsin’s boils to the rest of the world’s attention, there is only one logical way for Avery to regain the freedom he lost on November 9, 2005. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Attorney Kathleen Zellner must be overwhelmingly successful in convincing America’s judicial system that the person who killed Teresa, incinerated her body, and then cut her up into tiny pieces, was someone other than her client. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She must, in convincing fashion, put forth a compelling argument before the appeals court judges that the real evidence, the overlooked evidence, the concealed evidence, sheds light on the one or perhaps two culprits still roaming around and lurking in the shadows of society, bad people, terribly deranged, but people who still come and go freely in their Wisconsin communities to this very day, just as Manitowoc County’s dangerous sexual predator Gregory Allen was allowed to do for another decade until he was finally captured and put in prison for life because he could not stop attacking and raping women during the 1980s and 1990s.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What if Zellner at this stage of the post-conviction process is on the right path? ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What if she has uncovered the long suspected hidden truth, disturbing evidence that points to somebody other than Avery, but perhaps somebody who is still connected back to the family, somebody who was already familiar with the immediate landscape including Avery Road and Bear the dog? ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Regardless of your opinion about Avery’s guilt or innocence, you cannot deny that there were two strange people whose courtroom testimony helped sack Avery at his jury trial. One was Bobby, the nephew. The other was Scott Tadych, the abusive woman beater who is the current husband of Avery’s dysfunctional sister, Barb, who has become an outcast within her family.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Tadych has a reputation of being a thug and a compulsive liar. Nothing out of his mouth can be trusted. He is regarded as one of the meanest monsters who live in the Mishicot-Two Rivers area, and he’s behaved that way for years, court documents and police reports outline.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In November 2017, Zellner presented Wisconsin’s circuit court with reams of evidence pointing at Bobby Dassey and Scott Tadych as being the most likely people involved in Teresa’s death and dismemberment of her body. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This new evidence establishes a reasonable probability that a different result would be reached at a new trial based upon the totality of the new evidence. In summary, this evidence consists of brand-new admissions from Barb Tadych and Mr. Tadych that they were aware that Ms. Halbach left the Avery property prior to her murder and an affidavit from Barb’s stepson, Brad Dassey, that Barb tried to remove relevant and probative evidence from the Dassey computer before it was seized by police on April 21, 2006.”"), _c('span', {
    staticClass: "Endnote-Reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-012"
    }
  }, [_vm._v("(15)")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "footnote-014"
    }
  }, [_c('p', {
    staticClass: "Footnote-Text-numbered",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-014-backlink"
    }
  }, [_vm._v("13")]), _vm._v(".  Kathleen Zellner Sept. 27, 2018 at Maryville University, Peace and Justice Award lecture")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-013"
    }
  }, [_c('p', {
    staticClass: "Footnote-Text-numbered",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-013-backlink"
    }
  }, [_vm._v("14")]), _vm._v(".  Zellner interview with Newsweek, March 29, 2016")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-012"
    }
  }, [_c('p', {
    staticClass: "Footnote-Text-numbered",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_04#footnote-012-backlink"
    }
  }, [_vm._v("15")]), _vm._v(".  November 1, 2017, Zellner’s amended supplement to previously filed motion for reconsideration.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec51351","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter_04.vue
// module id = 84
// module chunks = 0